module.exports = {"621126100":"岷阳镇","621126101":"蒲麻镇","621126102":"西寨镇","621126103":"梅川镇","621126104":"西江镇","621126105":"闾井镇","621126106":"十里镇","621126107":"茶埠镇","621126108":"中寨镇","621126109":"清水镇","621126110":"寺沟镇","621126111":"麻子川镇","621126112":"维新镇","621126113":"禾驮镇","621126114":"马坞镇","621126204":"秦许乡","621126207":"申都乡","621126208":"锁龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621126.json
// module id = 3092
// module chunks = 0